import React from "react";
import { useTranslation } from "react-i18next";

import {
  HvGlobalActions,
  HvTypography,
  HvGrid,
} from "@hitachivantara/uikit-react-core";

import useStyles from "./styles";
import DetailsContent from "./DetailsContent";

interface DetailsProps {
  mode?: "add" | "edit";
}

const Details: React.FC<DetailsProps> = ({ mode = "add" }) => {
  const { t } = useTranslation("cameraAddEdit");
  const classes = useStyles();

  return (
    <HvGrid container className={classes.root}>
      <HvGrid xs={12} sm={12} item>
        <HvGlobalActions title={t("details.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("details.description")}
        </HvTypography>
      </HvGrid>
      <DetailsContent mode={mode} />
    </HvGrid>
  );
};

export default Details;
